<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">{{ day_trip.name }} ({{ day_trip.clients.length }}) ID: {{ this.$route.params.id }}</h1>
        <div v-if="day_trip.pick_up_time_to_be_confirmed" class="status-title" :style="{ 'backgroundColor': '#f0c427' }">
          Time to be confirmed
        </div>
        <div v-if="day_trip.ready_to_join" class="status-title" :style="{ 'backgroundColor': '#77b017' }">
          Join
        </div>
      </app-cells>
      <div class="info-cards">
        <div class="info-cards__card">
          <button @click="$modal.show('day-trip-modal')" class="info-cards__control">
            <img src="@/assets/img/edit-table-icon.svg" alt="">
          </button>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Activity:</span><span>{{ day_trip.activity.short_name }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item">
              <span>Date:</span><span>{{ dateFormat(day_trip.date) }}</span>
            </div>
            <div class="info-cards__row-item">
              <span>Time:</span><span>{{ day_trip.pick_up_time }}</span>
            </div>
          </div>
          <div class="info-cards__row">
            <div class="info-cards__row-item info-cards__row-item--full">
              <span>Pick-up location:</span> <span>{{ day_trip.pick_up_location.short_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <app-cells>
        <app-button
            @click.native="onShowCreatePopup"
            :disabled="day_trip.pick_up_time_to_be_confirmed"
        >
          Request transfer
        </app-button>
      </app-cells>
      <v-client-table
          :data="table.items"
          :columns="table.columns"
          :options="table.options"
          class="table-default"
      >
        <template #h__full_name>
          <div class="table-default__left">Full name</div>
        </template>
        <template #h__accomodation>
          <div class="table-default__left">Accommodation</div>
        </template>
        <template #h__group.name>
          <div class="table-default__left">Group</div>
        </template>
        <template #count="{ row, index }">{{ index }}</template>
        <template #full_name="{ row }">
          <div class="table-default__left table-default__left--photo">
            <span
              :class="`fflag ff-md fflag-${row.citizenship ? row.citizenship.code : 'empty'}`"
              v-tooltip="{ content: row.citizenship ? row.citizenship.name : 'Not provided', placement: 'top-start', offset: 10 }"
            ></span>
            <img v-if="!row.gender" src="@/assets/img/gender-plug-icon.svg" alt="">
            <img v-if="row.gender?.code === 'male'" src="@/assets/img/male-icon.svg" alt="">
            <img v-if="row.gender?.code === 'female'" src="@/assets/img/female-icon.svg" alt="">
            <router-link
                :to="{ name: 'clients-detail', params: { id: row.id } }"
                class="table-default__link-border"
            >
              {{ row.full_name }}
            </router-link>
            <span v-if="row.age">({{ row.age }} y.o.)</span>
            <img v-if="row.birthday" src="@/assets/img/birthday-icon.svg" alt="Birthday">
          </div>
        </template>
        <template #group.name="{ row }">
          <router-link
            :to="{ name: 'clients-groups-general', params: { id: row.group.id } }"
            class="table-default__link-border"
          >
            {{ row.group.name }}
          </router-link>
        </template>
        <template #manager="{ row }">
          <div class="table-default__controls">
            <div class="table-default__photo">
              <img
                  :src="getUserAvatar(row.manager.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.manager.full_name, placement: 'top-start', offset: 10, html: true }"
              >
            </div>
          </div>
        </template>
        <template #accomodation="{ row }">
          <template v-if="row.accomodation">
            <router-link
              :to="{ name: 'reservation-hotels-general', params: { id: row.accomodation.id } }"
              class="table-default__link-border"
            >
              {{ row.accomodation.hotel.name }}
            </router-link>
          </template>
          <template v-else><div class="table-default__left">-</div></template>
        </template>
      </v-client-table>
      <app-cells>
        <h2 class="title">Upcoming transfers</h2>
      </app-cells>
      <template v-if="upcoming_transfers.length">
        <div v-for="(transfer, index) in upcoming_transfers" :key="`upcoming_${transfer.id}`">
          <transfers-blocks
              @onOpenEditPopup="onOpenEditPopup"
              @onCancelledTransfer="onCancelledTransfer"
              @onDeleteTransfer="onDeleteTransfer"
              :transfer="transfer"
              :count="index + 1"
              :is_show_arrange_button="false"
          />
        </div>
      </template>
      <div v-else class="no-results">
        <img src="@/assets/img/schedule-plug-icon.svg" alt="">
        <div class="no-results__title">No Results</div>
        <div class="no-results__text">There’s no transfers yet</div>
      </div>
      <template v-if="archive_transfers.length">
        <app-cells>
          <h2 class="title">Archive transfers</h2>
        </app-cells>
        <div v-for="(transfer, index) in archive_transfers" :key="`archive_${transfer.id}`">
          <transfers-blocks
              :transfer="transfer"
              :count="index + 1"
              :is_show_arrange_button="false"
          />
        </div>
      </template>
    </template>
    <modal
        name="day-trip-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('day-trip-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Edit day trip</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckDayTripForm">
            <app-form-group label="Group name" label-for="group_name_day_trip" required>
              <app-input
                  v-model="day_trip_form.name"
                  :error="$v.day_trip_form.name.$error"
                  id="group_name_day_trip"
                  placeholder="Group name"
                  name="group_name_day_trip"
              />
              <template #error>
                <div v-if="$v.day_trip_form.name.$dirty && !$v.day_trip_form.name.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Activity" required>
              <app-select
                v-model="day_trip_form.activity"
                :options="day_trips_activity_options"
                :clearable="false"
                placeholder="Type"
                :error="$v.day_trip_form.activity.$error"
              />
              <template #error>
                <div v-if="$v.day_trip_form.activity.$dirty && !$v.day_trip_form.activity.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Date" required>
              <app-date-picker
                v-model="day_trip_form.date"
                placeholder="Tour start"
                :error="$v.day_trip_form.date.$error"
              />
              <template #error>
                <div v-if="$v.day_trip_form.date.$dirty && !$v.day_trip_form.date.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Pick-up location" required>
              <app-select
                @input="onLocationSelected"
                @search="onLocationSearch"
                v-model="day_trip_form.pick_up_location"
                :options="location_options"
                :clearable="false"
                placeholder="Pick-up location"
                :error="$v.day_trip_form.pick_up_location.$error"
              />
              <template #error>
                <div v-if="$v.day_trip_form.pick_up_location.$dirty && !$v.day_trip_form.pick_up_location.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Pick-up time" label-for="pick_up_time" required>
              <app-input
                  v-model="day_trip_form.pick_up_time"
                  v-mask="'99:99'"
                  placeholder="Time"
                  autocomplete="off"
                  id="pick_up_time-time"
                  name="pick_up_time"
                  @paste.native.prevent
                  :error="$v.day_trip_form.pick_up_time.$error"
              />
              <template #error>
                <div v-if="$v.day_trip_form.pick_up_time.$dirty && !$v.day_trip_form.pick_up_time.required">Required field</div>
                <div v-if="$v.day_trip_form.pick_up_time.$dirty && !$v.day_trip_form.pick_up_time.timeRegex">Wrong time</div>
              </template>
            </app-form-group>
            <app-cells>
              Pick-up time to be confirmed <app-switcher v-model="day_trip_form.pick_up_time_to_be_confirmed" />
            </app-cells>
            <app-cells>
              Ready to join <app-switcher v-model="day_trip_form.ready_to_join" />
            </app-cells>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.day_trip_form.$error" type="submit" ref="day_trip_submit">Update day trip</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="request-popup"
        :width="500"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('request-popup')" class="popup__close" type="button"></button>
        <div class="popup__title">Request transfer</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckRequestForm">
            <app-form-group label="Name" label-for="cl_name" required>
              <app-input
                  v-model="request_form.name"
                  placeholder="Name"
                  id="name"
                  name="cl_name"
                  :error="$v.request_form.name.$error"
              />
              <template #error>
                <div v-if="$v.request_form.name.$dirty && !$v.request_form.name.required">Required field</div>
              </template>
            </app-form-group>
            <draggable
                :list="request_form.points"
                v-bind="dragOptions"
                handle=".sortable__handle"
                class="transfer-sortable transfer-sortable--lite"
            >
              <transition-group type="transition" :name="'flip-list'" tag="div">
                <div v-for="(element, index) in request_form.points" :key="`points_${index}`" class="transfer-sortable__item">
                  <div class="transfer-sortable__row">
                    <app-form-group :label="`Destination ${index + 1}`" class="form-group--no-indent" required>
                      <app-select
                        @input="onRequestLocationSelected(element.location, index)"
                        @search="onLocationSearch"
                        v-model="element.location"
                        :options="location_options"
                        :filterable="false"
                        :clearable="false"
                        placeholder="Select"
                        :error="$v.request_form.points.$each[index].location.$error"
                      />
                      <template #error>
                        <div v-if="$v.request_form.points.$each[index].location.$dirty && !$v.request_form.points.$each[index].location.required">Required field</div>
                      </template>
                    </app-form-group>
                    <button type="button" class="transfer-sortable__btn sortable__handle">
                      <img src="@/assets/img/sortable-arrow.svg" alt="Arrow">
                    </button>
                    <button
                        v-if="index !== 0"
                        @click="onRemoveDestination(index)"
                        class="transfer-sortable__close"
                        type="button"
                    >
                      <img src="@/assets/img/delete-transfer.svg" alt="Delete">
                    </button>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <app-cells>
              <app-button @click.native="onAddDestination" size="small">
                <img src="@/assets/img/plus-icon.svg" alt="Add">
                <span>Add destination</span>
              </app-button>
            </app-cells>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                  v-model="request_form.notes"
                  id="notes"
                  placeholder="Notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="request_submit">Create request</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
        name="accept-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to cancelled this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="cancelTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
        name="accept-delete-modal"
        :width="400"
        :height="'auto'"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="false"
        class="modal-not-overflow"
        draggable=".popup__title"
        :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to deleted this transfer?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-delete-modal')" theme="dark">Delete</app-button>
            <app-button @click.native="deleteTransfer" ref="delete">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteTransfer,
  getDayTripsActivity,
  getDayTripsDayTrip,
  getDayTripsDayTripClients,
  getGoogleSearch,
  getTransfersList,
  patchDayTripsDayTrip,
  patchDayTripTransfer,
  patchTransfers,
  postLocation,
  postTransferDayTrip,
} from '@/http'
import { format, parse, parseISO } from 'date-fns'
import { helpers, required } from 'vuelidate/lib/validators'
import debounce from 'lodash/debounce'
import draggable from 'vuedraggable'
import TransfersBlocks from '@/views/transfer/transfers/TransfersBlocks'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'DayTripsGroupsDetail',
  components: { TransfersBlocks, draggable },
  data() {
    return {
      is_loaded: false,
      day_trip: {},
      current_transfer_id: null,
      table: {
        items: [],
        columns: ['count', 'full_name', 'group.name', 'manager', 'accomodation'],
        options: {
          headings: {
            'count': '#',
            'full_name': 'Full name',
            'group.name': 'Group',
            'manager': 'Manager',
            'accomodation': 'Accommodation',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      day_trip_form: {},
      day_trips_activity_options: [],
      location_options: [],
      request_form: { name: '', points: [{ location: null }] },
      upcoming_transfers: [],
      archive_transfers: [],
      is_create: true
    }
  },
  validations: {
    day_trip_form: {
      name: { required },
      date: { required },
      pick_up_time: { required, timeRegex },
      activity: { required },
      pick_up_location: { required },
    },
    request_form: {
      name: { required },
      points: {
        $each: {
          location: { required },
        }
      },
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'destination',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  },
  created() {
    Promise.all([
      getDayTripsDayTrip(this.$route.params.id),
      getDayTripsDayTripClients(this.$route.params.id),
      getTransfersList({ day_trip: this.$route.params.id, category: 'upcoming' }),
      getTransfersList({ day_trip: this.$route.params.id, category: 'archive' })
    ])
      .then(res => {
        this.day_trip = res[0].data
        document.title = `${this.day_trip.name} (${this.day_trip.clients.length}) ID: ${ this.$route.params.id } | Altezza Board`
        this.day_trip_form = { ...res[0].data }
        this.table.items = res[1].data.clients
        this.request_form.name = this.day_trip.name
        this.upcoming_transfers = res[2].data
        this.archive_transfers = res[3].data
        this.is_loaded = true
      })
    getDayTripsActivity().then(res => { this.day_trips_activity_options = res.data })
  },
  methods: {
    onShowCreatePopup() {
      this.request_form = { name: this.day_trip.name, points: [{ location: null }] }
      this.$v.request_form.$reset()
      this.is_create = true
      this.$modal.show('request-popup')
    },
    onOpenEditPopup(transfer) {
      this.request_form = { ...transfer, points: [ ...transfer.points ] }
      this.$v.request_form.$reset()
      this.is_create = false
      this.$modal.show('request-popup')
    },
    fetchItems() {
      Promise.all([
        getTransfersList({ day_trip: this.$route.params.id, category: 'upcoming' }),
        getTransfersList({ day_trip: this.$route.params.id, category: 'archive' })
      ])
        .then(res => {
          this.upcoming_transfers = res[0].data
          this.archive_transfers = res[1].data
          this.$modal.hide('arrange-popup')
        })
    },
    onCheckRequestForm() {
      this.$v.request_form.$touch()
      if (this.$v.request_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendRequestForm()
      }
    },
    sendRequestForm() {
      this.$refs.request_submit.preload = true
      if (this.is_create) {
        postTransferDayTrip(this.normalizeRequestForm())
          .then(() => {
            this.$modal.hide('request-popup')
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Transfer requested',
            })
          })
          .catch(() => { this.$refs.request_submit.preload = false })
      } else {
        patchDayTripTransfer(this.request_form.id, this.normalizeRequestForm())
          .then(() => {
            this.$modal.hide('request-popup')
            this.fetchItems()
            this.$notify({
              type: 'success',
              title: 'Transfer saved',
            })
          })
          .catch(() => { this.$refs.request_submit.preload = false })
      }
    },
    normalizeRequestForm() {
      const normalizedForm = {}

      normalizedForm.name = this.request_form.name
      normalizedForm.points = this.request_form.points.map((item, index) => ({ location: item.location.id, sort: index }))
      normalizedForm.day_trip = +this.$route.params.id
      normalizedForm.notes = this.request_form.notes
      return normalizedForm
    },
    onCancelledTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-modal')
    },
    cancelTransfer() {
      this.$refs.delete.preload = true
      patchTransfers(this.current_transfer_id, { status: 'cancelled' })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer cancelled',
          })
          this.fetchItems()
          this.$modal.hide('accept-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onDeleteTransfer(id) {
      this.current_transfer_id = id
      this.$modal.show('accept-delete-modal')
    },
    deleteTransfer() {
      this.$refs.delete.preload = true
      deleteTransfer(this.current_transfer_id)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Transfer deleted',
          })
          this.fetchItems()
          this.$modal.hide('accept-delete-modal')
        })
        .catch(() => { this.$refs.delete.preload = false })
    },
    onRemoveDestination(index) {
      this.request_form.points.splice(index, 1)
      this.$v.request_form.points.$touch()
    },
    onAddDestination() {
      this.request_form.points.push({ location: null })
    },
    onRequestLocationSelected({ name, place_id }, index) {
      this.$refs.request_submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.request_form.points[index].location = res.data
        this.$refs.request_submit.preload = false
      })
    },
    onLocationSelected({ name, place_id }) {
      this.$refs.day_trip_submit.preload = true
      postLocation({ name, place_id }).then(res => {
        this.day_trip_form.pick_up_location = res.data
        this.$refs.day_trip_submit.preload = false
      })
    },
    onCheckDayTripForm() {
      this.$v.day_trip_form.$touch()
      if (this.$v.day_trip_form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendAddDayTripForm()
      }
    },
    sendAddDayTripForm() {
      this.$refs.day_trip_submit.preload = true
      patchDayTripsDayTrip(this.$route.params.id, this.normalizeForm())
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Day trip edited',
          })
          getDayTripsDayTrip(this.$route.params.id)
            .then(res => {
              this.day_trip = res.data
              this.day_trip_form = { ...res.data }
            })
          this.$modal.hide('day-trip-modal')
        })
        .catch(() => { this.$refs.day_trip_submit.preload = false })
    },
    normalizeForm() {
      const form = { ...this.day_trip_form }

      form.activity = form.activity.id
      form.pick_up_location = form.pick_up_location.id
      delete form.clients
      return form
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : ''
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : ''
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onLocationSearch(search, loading) {
      loading(true)
      this.searchLocation(loading, search, this)
    },
    searchLocation: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.location_options = []
      } else {
        getGoogleSearch(search).then(response => {
          vm.location_options = response.data
          loading(false)
        })
      }
    }, 350),
  }
}
</script>
